import React from 'react';
import { Save } from 'lucide-react';
import { Modal } from '../../../../../../../components/ui/Modal';
import type { Perfil } from '../../../../types';

interface PerfilModalProps {
  open: boolean;
  onClose: () => void;
  editingPerfil: Perfil | null;
  perfilForm: { id: string; nome: string; descricao: string; ordem: number; isInterno: boolean };
  setPerfilForm: React.Dispatch<React.SetStateAction<{ id: string; nome: string; descricao: string; ordem: number; isInterno: boolean }>>;
  onSubmit: (e: React.FormEvent) => Promise<void>;
}

export function PerfilModal({
  open,
  onClose,
  editingPerfil,
  perfilForm,
  setPerfilForm,
  onSubmit,
}: PerfilModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={editingPerfil ? 'Editar Perfil' : 'Novo Perfil'}
      size="default"
    >
      <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {!editingPerfil && (
          <div>
            <label style={{ display: 'block', fontSize: '.75rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6 }}>Identificador do Perfil (ID único)</label>
            <input
              type="text"
              required
              placeholder="Ex: professores, diretores, custom-perfil"
              value={perfilForm.id}
              onChange={(e) => setPerfilForm({ ...perfilForm, id: e.target.value.toLowerCase().replace(/[^a-z0-9-_]/g, '') })}
              className="ecad-input-premium"
            />
            <span style={{ fontSize: '.68rem', color: 'var(--text-muted)' }}>Apenas letras minúsculas, números e traços.</span>
          </div>
        )}
        <div>
          <label style={{ display: 'block', fontSize: '.75rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6 }}>Nome do Perfil</label>
          <input
            type="text"
            required
            placeholder="Ex: Professores"
            value={perfilForm.nome}
            onChange={(e) => setPerfilForm({ ...perfilForm, nome: e.target.value })}
            className="ecad-input-premium"
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '.75rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6 }}>Descrição</label>
          <textarea
            rows={3}
            placeholder="Descreva o propósito deste perfil de treinamento..."
            value={perfilForm.descricao}
            onChange={(e) => setPerfilForm({ ...perfilForm, descricao: e.target.value })}
            className="ecad-textarea-premium"
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '.75rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: 6 }}>Ordem de Exibição</label>
          <input
            type="number"
            required
            value={perfilForm.ordem}
            onChange={(e) => setPerfilForm({ ...perfilForm, ordem: Number(e.target.value) })}
            className="ecad-input-premium"
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 10 }}>
          <button type="button" onClick={onClose} className="btn-cancel" style={{ height: 36, padding: '0 16px', fontSize: '.8rem', borderRadius: 8 }}>
            Cancelar
          </button>
          <button type="submit" className="btn-primary" style={{ display: 'flex', alignItems: 'center', gap: 6, height: 36, padding: '0 16px', fontSize: '.8rem', borderRadius: 8 }}>
            <Save size={14} /> Salvar Perfil
          </button>
        </div>
      </form>
    </Modal>
  );
}
